import { Flex } from '@chakra-ui/react';
import Card from 'components/card/Card';
import FormCadastrarEditarOportunidade from 'components/forms/FormCadastrarEditarOportunidade';
import { SidebarHelpContext } from 'contexts/SidebarHelpContext';
import { ISidebarHelp } from 'models/sidebarHelp/sidebarHelp.model';
import moment from 'moment';
import { useContext, useEffect, useMemo } from 'react';
import { URL_CT360, URL_FALE_CONOSCO } from 'utils/consts/global';

export default function CadastrarOportunidades() {
	const { setters } = useContext(SidebarHelpContext);
	const { setDataSidebar } = setters;

	const helpCadastroOportunidades = useMemo(
		(): ISidebarHelp => ({
			title: 'Cadastrar Oportunidades',
			firstParagraph:
				'Para cadastrar uma nova oportunidade, selecione a Competência desejada, o Cliente, Família e Produto, Quantidade e Membro responsável pela oportunidade.',
			secondParagraph:
				'Cadastre previamente os clientes através da importação de vendas em Cadastros > Comercial > Vendas; os membros em Cadastros > Comercial > Membros; e os produtos em Cadastros > Produto.',
			firstLink: URL_CT360,
			secondLink: URL_FALE_CONOSCO,
		}),
		[]
	);

	useEffect(() => {
		setDataSidebar(helpCadastroOportunidades);
	}, [helpCadastroOportunidades, setDataSidebar]);

	const formInitialState = {
		data: moment().format('YYYY-MM-DD'),
		ciclo_id: null,
		cliente_id: null,
		familia_id: null,
		produto_id: null,
		quantidade: null,
		receita_bruta: null,
		canal_venda_id: null,
		membro_id: null,
	};

	return (
		<Flex
			direction='column'
			pt={{ sm: '125px', lg: '75px' }}
		>
			<Card px='0px'>
				<FormCadastrarEditarOportunidade
					initialState={formInitialState}
				/>
			</Card>
		</Flex>
	);
}
